// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_playerInfo__FJg5D {
  height: 100%;
  width: 0;
  overflow: hidden;
  right: 0;
  display: flex;
  background-color: rgba(216, 235, 255, 0.1254901961);
  flex-direction: column;
  border-left: 1px solid #dce1e6;
  color: #4a596a;
}
@media (max-width: 1480px) {
  .style_playerInfo__FJg5D {
    position: absolute;
    background-color: #ffffff;
  }
}
.style_playerInfo__FJg5D.style_playerInfoOpen__8ZHju {
  width: 350px;
}
@media (max-width: 556px) {
  .style_playerInfo__FJg5D.style_playerInfoOpen__8ZHju {
    padding: 0 200px;
    margin-top: 73px;
    width: auto;
    width: 100%;
    padding: 0;
    height: calc(100% - 73px);
  }
}
.style_playerInfo__FJg5D .style_fixedInfo__8gdT2 {
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 24px 16px 0 16px;
}
.style_playerInfo__FJg5D .style_fixedInfo__8gdT2 .style_playerAvatarCell__76oww {
  width: 100%;
  margin: 0px;
  padding: 0px;
  height: 55px;
  align-content: center;
  display: inline-flexbox;
  flex-direction: row;
}
.style_playerInfo__FJg5D .style_fixedInfo__8gdT2 .style_playerAvatarCell__76oww .style_playerAvatar__Y0zSy {
  border: 2px solid rgb(255, 86, 86);
  border-radius: 25px;
  margin: 5px;
  padding: 0px;
}
.style_playerInfo__FJg5D .style_fixedInfo__8gdT2 .style_playerAvatarCell__76oww .style_playerAvatarOk__oKrir {
  border-radius: 15px;
  margin-top: 2px;
  padding: 5px;
}
.style_playerInfo__FJg5D .style_fixedInfo__8gdT2 .style_playerAvatarCell__76oww .style_playerInfoCancel__umZ1H {
  align-items: flex-end;
  display: inline-flexbox;
  flex-direction: row;
  position: absolute;
  right: 16px;
  top: 24px;
}
@media (max-width: 556px) {
  .style_playerInfo__FJg5D .style_fixedInfo__8gdT2 .style_playerAvatarCell__76oww .style_playerInfoCancel__umZ1H {
    display: none;
  }
}
.style_playerInfo__FJg5D .style_fixedInfo__8gdT2 .style_playerRealName__5gS\\+R {
  font-size: large;
  font-weight: 700;
  width: 100%;
  word-break: break-all;
  border: none;
  padding: 5px;
}
.style_playerInfo__FJg5D .style_fixedInfo__8gdT2 .style_playerRealName__5gS\\+R .style_vip__B1P9z {
  margin-left: 6px;
  height: 24px;
  width: 24px;
}
.style_playerInfo__FJg5D .style_playerInfoTabs__xIQC2 {
  width: 100%;
  display: inline-flex;
  flex-direction: row;
}
.style_playerInfo__FJg5D .style_playerInfoTabs__xIQC2 .style_piTab__h9vpk {
  font-size: medium;
  font-weight: 500;
  width: 50%;
  display: inline-flex;
  justify-content: center;
  cursor: pointer;
  padding-bottom: 4px;
  border-bottom: 2px solid #e9e9eb;
  margin-top: 25px;
}
.style_playerInfo__FJg5D .style_playerInfoTabs__xIQC2 .style_piTab__h9vpk.style_active__-ytvV {
  font-size: medium;
  font-weight: 500;
  color: #5f8fdf;
  width: 50%;
  display: inline-flex;
  justify-content: center;
  cursor: pointer;
  padding-bottom: 4px;
  border-bottom: 2px solid #5f8fdf;
}
.style_playerInfo__FJg5D .style_stretchInfo__-J9yP {
  display: flex;
  flex-direction: column;
  caret-color: transparent;
  scrollbar-width: 10px;
  overflow-y: auto;
  padding: 0 16px;
}
.style_playerInfo__FJg5D .style_stretchInfo__-J9yP::-webkit-scrollbar {
  width: 7px;
  background-color: transparent;
}
.style_playerInfo__FJg5D .style_stretchInfo__-J9yP::-webkit-scrollbar-thumb {
  background: rgba(196, 200, 212, 0.7960784314);
  border-radius: 7px;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
}
.style_playerInfo__FJg5D .style_stretchInfo__-J9yP .style_playerInfoLine__SmuMu {
  width: 100%;
  display: inline-flex;
  flex-direction: row;
  gap: 16px;
}
.style_playerInfo__FJg5D .style_stretchInfo__-J9yP .style_detailsLineDescr__HMy6e {
  display: inline-flex;
  justify-content: left;
  flex-direction: column;
  padding: 12px 0;
  width: 100%;
}
.style_playerInfo__FJg5D .style_stretchInfo__-J9yP .style_detailsLineDescr__HMy6e .style_editNotes__7rzi4 {
  display: inline-flex;
  flex-direction: row;
}
.style_playerInfo__FJg5D .style_stretchInfo__-J9yP .style_detailsLineDescr__HMy6e .style_editNotes__7rzi4 .style_detailsLineLabel__IZql7 {
  text-align: left;
  font-size: smaller;
  font-weight: 200;
  color: #909399;
  justify-content: left;
  width: 90%;
}
.style_playerInfo__FJg5D .style_stretchInfo__-J9yP .style_detailsLineDescr__HMy6e .style_detailsLineValue__\\+tUyB {
  text-align: left;
}
.style_playerInfo__FJg5D .style_stretchInfo__-J9yP .style_detailsLine__rB-ms {
  display: inline-flex;
  justify-content: left;
  flex-direction: column;
  padding: 12px 0;
  width: 100%;
}
.style_playerInfo__FJg5D .style_stretchInfo__-J9yP .style_detailsLine__rB-ms .style_detailsLineLabel__IZql7 {
  text-align: left;
  font-size: smaller;
  font-weight: 200;
  color: #909399;
}
.style_playerInfo__FJg5D .style_stretchInfo__-J9yP .style_detailsLine__rB-ms .style_detailsLineValue__\\+tUyB {
  text-align: left;
}
.style_playerInfo__FJg5D .style_stretchInfo__-J9yP .style_detailsLine__rB-ms .style_detailsLineValueChk__FuQEA {
  text-align: left;
  display: inline-flex;
  flex-direction: row;
}
.style_playerInfo__FJg5D .style_stretchInfo__-J9yP .style_detailsLine__rB-ms .style_detailsLineValueChk__FuQEA .style_msgSwitch__6Vefs {
  margin-left: 5px;
}
.style_playerInfo__FJg5D .style_stretchInfo__-J9yP .style_detailsLine__rB-ms .style_detailsLineValueChk__FuQEA .style_yesNoWrap__vZEwz {
  padding-left: 15px;
  font-size: small;
  font-weight: 400;
}
.style_playerInfo__FJg5D .style_stretchInfo__-J9yP .style_detailsLine__rB-ms .style_playerIdLine__e1Re5 {
  display: inline-flex;
  flex-direction: row;
}
.style_playerInfo__FJg5D .style_stretchInfo__-J9yP .style_detailsLine__rB-ms .style_playerIdLine__e1Re5 .style_editorPlayerId__jDwnu {
  justify-content: left;
  width: 90%;
  display: inline-flex;
  flex-direction: column;
}
.style_playerInfo__FJg5D .style_stretchInfo__-J9yP .style_cb__fxkUA {
  border-bottom: 1px solid #e9e9eb;
}
.style_infoUserWrapper__XDwjT {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  padding: 0 16px;
}
.style_infoUserWrapper__XDwjT .style_playerInfoLine__SmuMu {
  width: 100%;
  display: inline-flex;
  flex-direction: row;
  gap: 16px;
  border-bottom: 1px solid #e9e9eb;
}
.style_infoUserWrapper__XDwjT .style_playerInfoLine__SmuMu:last-of-type {
  border-bottom: none;
}
.style_infoUserWrapper__XDwjT .style_playerInfoLine__SmuMu .style_detailsLine__rB-ms {
  display: inline-flex;
  justify-content: left;
  flex-direction: column;
  padding: 12px 0;
  width: 100%;
}
.style_infoUserWrapper__XDwjT .style_playerInfoLine__SmuMu .style_detailsLine__rB-ms .style_detailsLineLabel__IZql7 {
  text-align: left;
  font-size: smaller;
  font-weight: 200;
  color: #909399;
}
.style_infoUserWrapper__XDwjT .style_playerInfoLine__SmuMu .style_detailsLine__rB-ms .style_detailsLineValue__\\+tUyB {
  text-align: left;
}

.style_player-real-name__AG86n {
  font-size: large;
  font-weight: 700;
  display: inline-flex;
  width: 100%;
  justify-content: center;
  border: none;
  height: 35px;
  padding: 5px;
}

.style_player-payid__p8Fn8 {
  display: inline-flex;
  width: 100%;
  justify-content: center;
  border: none;
  height: 35px;
  padding: 5px;
}

.style_details-line-rec__p5GwT {
  width: 100%;
  flex-direction: row;
  display: inline-flex;
  border-bottom: 1px solid #e9e9eb;
}

.style_cb__fxkUA {
  border-bottom: 1px solid #e9e9eb;
}

.style_edit-btn__0WxUC {
  background-color: white;
  margin-bottom: 1px;
  padding-top: 5px;
  color: black;
  border: 1px solid rgb(210, 216, 223);
  border-radius: 7px;
}

.style_edit-span__8ealJ {
  font-size: medium;
  font-weight: 500;
  vertical-align: middle;
  padding-top: 5px;
  padding-left: 5px;
  color: black;
}

.style_edit-pen__vBLe3 {
  color: rgb(95, 143, 223);
}

.style_change-dollar__wv7-6 {
  color: rgb(95, 143, 223);
  padding-top: 5px;
}

.style_edit-edit__9FeFJ {
  width: 100%;
  flex-direction: row;
  display: inline-flex;
  align-content: center;
  justify-content: center;
}

.style_details-line-edit__ndMtk {
  width: 35px;
  margin: 12px 0;
}

.style_img-space__Qe4Ze {
  margin-left: 5px;
}

.style_details-line__1d77P {
  display: inline-flex;
  justify-content: left;
  flex-direction: column;
  padding: 12px 0;
  width: 100%;
}

.style_mel__u5-Kn {
  height: 75px;
}

.style_money-edit__5Bhse {
  padding-left: 15px;
  display: inline-block;
  caret-color: black;
}

.style_currency-sign__tA8Mv {
  position: relative;
  left: 1px;
  top: 0;
  width: 18px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.style_notes-edit__3GBPW {
  height: 100px;
  padding-left: 5px;
  padding-top: 5px;
  vertical-align: top;
  text-align: left;
  caret-color: black;
}

.style_msg-switch__Kyu\\+J {
  margin-left: 5px;
}

.style_notes-edit-save__EJnw5 {
  font-size: medium;
  font-weight: 500;
  width: 140px;
  color: white;
  background-color: rgb(95, 143, 223);
}

.style_notes-edit-cancel__a6FHe {
  font-size: medium;
  font-weight: 500;
  width: 140px;
  color: black;
  background-color: white;
  border: 1px solid rgb(210, 216, 223);
}

.style_dle__K72up {
  margin-top: 50px;
  margin-bottom: 12px 0;
}

.style_dle-cancel__LkJN9 {
  margin-top: 50px;
  margin-bottom: 12px 0;
}

.style_dle-notes-cancel__deUl6 {
  margin-bottom: 35px;
}

.style_edit-notes__QMH19 {
  display: inline-flex;
  flex-direction: row;
}

.style_edit-player-id__HedEz {
  display: inline-flex;
  flex-direction: row;
}

.style_player-id-line__QMPHx {
  display: inline-flex;
  flex-direction: row;
}

.style_edit-pen-notes__InLY1 {
  justify-content: right;
  width: 10%;
}

.style_edit-player-id__HedEz {
  justify-content: right;
  width: 10%;
}

.style_editor-player-id__p6X2C {
  justify-content: left;
  width: 90%;
  display: inline-flex;
  flex-direction: column;
}

.style_details-line-descr__W0H9J {
  display: inline-flex;
  justify-content: left;
  flex-direction: column;
  padding: 12px 0;
  width: 100%;
}

.style_end-line__hpIaS {
  border-bottom: none;
}

.style_details-line-label__pDqvv {
  text-align: left;
  font-size: smaller;
  font-weight: 200;
  color: #909399;
}

.style_details-line-value__i0nD8 {
  text-align: left;
}

.style_details-line-value-chk__1jxmJ {
  text-align: left;
  display: inline-flex;
  flex-direction: row;
}

.style_yesNoWrap__vZEwz {
  padding-left: 15px;
  font-size: small;
  font-weight: 400;
}

.style_edit-pen__vBLe3 {
  color: rgb(95, 143, 223);
  margin-top: 5px;
  cursor: pointer;
}

.style_dlg-btns__LEuER {
  width: 100%;
  display: flex;
  gap: 16px;
}
.style_dlg-btns__LEuER button {
  width: 100%;
}

.style_dlg-btn-ok__FaOXf {
  align-self: center;
  display: inline-flex;
  padding-left: 10px;
}

.style_dlg-btn-cancel__H2jTt {
  display: inline-flex;
  align-self: center;
  padding-right: 10px;
}

.style_dlg-btn-ok-ctrl__YUWXS {
  margin-right: 10px;
  width: 140px;
  font-size: medium;
  font-weight: 500;
  color: white;
  background-color: rgb(95, 143, 223);
}

.style_dlg-btn-cancel-ctrl__w1tEH {
  margin-left: 10px;
  width: 140px;
  font-size: medium;
  font-weight: 500;
  color: black;
  background-color: white;
  border: 1px solid rgb(210, 216, 223);
}

.style_dlg-header__xFOe5 {
  caret-color: transparent;
  width: 100%;
  display: inline-flex;
  flex-direction: row;
}

.style_dlg-header-ico__Asaui {
  position: relative;
  left: 10px;
  top: 5px;
  width: 25px;
  height: 25px;
  display: inline-flex;
}

.style_dlg-body-msg__8ka4U {
  caret-color: transparent;
  padding-bottom: 5px;
  display: inline-flex;
}`, "",{"version":3,"sources":["webpack://./src/components/Dialog/PlayerInfo/style.module.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,QAAA;EACA,gBAAA;EACA,QAAA;EACA,aAAA;EACA,mDAAA;EACA,sBAAA;EACA,8BAAA;EACA,cCCe;ADFjB;AAGE;EAXF;IAYI,kBAAA;IACA,yBCfI;EDeN;AACF;AAEE;EACE,YAAA;AAAJ;AAeI;EAhBF;IAiBI,gBAAA;IACA,gBAAA;IACA,WAAA;IACA,WAAA;IACA,UAAA;IACA,yBAAA;EAZJ;AACF;AAeE;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;AAbJ;AAeI;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;AAbN;AAeM;EACE,kCAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AAbR;AAgBM;EACE,mBAAA;EACA,eAAA;EACA,YAAA;AAdR;AAiBM;EACE,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AAfR;AAiBQ;EARF;IASI,aAAA;EAdR;AACF;AAkBI;EACE,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,YAAA;AAhBN;AAkBM;EACE,gBAAA;EACA,YAAA;EACA,WAAA;AAhBR;AAqBE;EACE,WAAA;EACA,oBAAA;EACA,mBAAA;AAnBJ;AAqBI;EACE,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,oBAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;AAnBN;AAqBM;EACE,iBAAA;EACA,gBAAA;EACA,cClHO;EDmHP,UAAA;EACA,oBAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;EACA,gCAAA;AAnBR;AAwBE;EACE,aAAA;EACA,sBAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;AAtBJ;AAwBI;EACE,UAAA;EACA,6BAAA;AAtBN;AAyBI;EACE,6CAAA;EACA,kBAAA;EACA,4BAAA;EAAA,oBAAA;AAvBN;AA0BI;EACE,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;AAxBN;AA2BI;EACE,oBAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;AAzBN;AA2BM;EACE,oBAAA;EACA,mBAAA;AAzBR;AA2BQ;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cC/JO;EDgKP,qBAAA;EACA,UAAA;AAzBV;AA4BM;EACE,gBAAA;AA1BR;AA8BI;EACE,oBAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;AA5BN;AA8BM;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cCpLS;ADwJjB;AA+BM;EACE,gBAAA;AA7BR;AAgCM;EACE,gBAAA;EACA,oBAAA;EACA,mBAAA;AA9BR;AAgCQ;EACE,gBAAA;AA9BV;AAiCQ;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;AA/BV;AAmCM;EACE,oBAAA;EACA,mBAAA;AAjCR;AAmCQ;EACE,qBAAA;EACA,UAAA;EACA,oBAAA;EACA,sBAAA;AAjCV;AAsCI;EACE,gCAAA;AApCN;AAkDA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;AAhDF;AAkDE;EACE,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,gCAAA;AAhDJ;AAkDI;EACE,mBAAA;AAhDN;AAmDI;EACE,oBAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;AAjDN;AAmDM;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cCnQS;ADkNjB;AAoDM;EACE,gBAAA;AAlDR;;AA0DA;EACE,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;AAvDF;;AA0DA;EACE,oBAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;AAvDF;;AA8FA;EACE,WAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AA3FF;;AA8FA;EACE,gCAAA;AA3FF;;AA8FA;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;AA3FF;;AA8FA;EACE,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AA3FF;;AA8FA;EACE,wBAAA;AA3FF;;AA8FA;EACE,wBAAA;EACA,gBAAA;AA3FF;;AA8FA;EACE,WAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,uBAAA;AA3FF;;AA8FA;EACE,WAAA;EACA,cAAA;AA3FF;;AA8FA;EACE,gBAAA;AA3FF;;AA8FA;EACE,oBAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;AA3FF;;AA+FA;EACE,YAAA;AA5FF;;AA+FA;EACE,kBAAA;EACA,qBAAA;EACA,kBAAA;AA5FF;;AA+FA;EACE,kBAAA;EACA,SAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AA5FF;;AA+FA;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AA5FF;;AA+FA;EACE,gBAAA;AA5FF;;AA+FA;EACE,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,mCAAA;AA5FF;;AA+FA;EACE,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,oCAAA;AA5FF;;AA+FA;EACE,gBAAA;EACA,qBAAA;AA5FF;;AA+FA;EACE,gBAAA;EACA,qBAAA;AA5FF;;AA+FA;EACE,mBAAA;AA5FF;;AA+FA;EACE,oBAAA;EACA,mBAAA;AA5FF;;AA+FA;EACE,oBAAA;EACA,mBAAA;AA5FF;;AA+FA;EACE,oBAAA;EACA,mBAAA;AA5FF;;AA+FA;EACE,sBAAA;EACA,UAAA;AA5FF;;AA+FA;EACE,sBAAA;EACA,UAAA;AA5FF;;AA+FA;EACE,qBAAA;EACA,UAAA;EACA,oBAAA;EACA,sBAAA;AA5FF;;AA+FA;EACE,oBAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;AA5FF;;AA+FA;EACE,mBAAA;AA5FF;;AAmGA;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAhGF;;AAmGA;EACE,gBAAA;AAhGF;;AAmGA;EACE,gBAAA;EACA,oBAAA;EACA,mBAAA;AAhGF;;AAmGA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;AAhGF;;AAmGA;EACE,wBAAA;EACA,eAAA;EACA,eAAA;AAhGF;;AAmGA;EACE,WAAA;EACA,aAAA;EACA,SAAA;AAhGF;AAkGE;EACE,WAAA;AAhGJ;;AAoGA;EACE,kBAAA;EACA,oBAAA;EACA,kBAAA;AAjGF;;AAoGA;EACE,oBAAA;EACA,kBAAA;EACA,mBAAA;AAjGF;;AAoGA;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,mCAAA;AAjGF;;AAoGA;EACE,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,oCAAA;AAjGF;;AAoGA;EACE,wBAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;AAjGF;;AAoGA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AAjGF;;AA2GA;EACE,wBAAA;EACA,mBAAA;EACA,oBAAA;AAxGF","sourcesContent":["@import '../../../variables.scss';\n\n.playerInfo {\n  height: 100%;\n  width: 0;\n  overflow: hidden;\n  right: 0;\n  display: flex;\n  background-color: #d8ebff20;\n  flex-direction: column;\n  border-left: 1px solid $gray-border;\n  color: $text-color-800;\n\n  @media (max-width: 1480px) {\n    position: absolute;\n    background-color: $white;\n  }\n\n  &.playerInfoOpen {\n    width: 350px;\n\n    // @media (max-width: 991.98px) {\n    //   padding: 0 200px;\n    //   background-color: $white;\n    //   position: absolute;\n    //   margin-top: 73px;\n    //   width: 100%;\n    //   height: calc(100% - 73px);\n    // }\n\n    // @media (max-width: 760px) {\n    //   padding: 0 100px;\n    // }\n\n    @media (max-width: 556px) {\n      padding: 0 200px;\n      margin-top: 73px;\n      width: auto;\n      width: 100%;\n      padding: 0;\n      height: calc(100% - 73px);\n    }\n  }\n\n  .fixedInfo {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    padding: 24px 16px 0 16px;\n\n    .playerAvatarCell {\n      width: 100%;\n      margin: 0px;\n      padding: 0px;\n      height: 55px;\n      align-content: center;\n      display: inline-flexbox;\n      flex-direction: row;\n\n      .playerAvatar {\n        border: 2px solid rgb(255, 86, 86);\n        border-radius: 25px;\n        margin: 5px;\n        padding: 0px;\n      }\n\n      .playerAvatarOk {\n        border-radius: 15px;\n        margin-top: 2px;\n        padding: 5px;\n      }\n\n      .playerInfoCancel {\n        align-items: flex-end;\n        display: inline-flexbox;\n        flex-direction: row;\n        position: absolute;\n        right: 16px;\n        top: 24px;\n\n        @media (max-width: 556px) {\n          display: none;\n        }\n      }\n    }\n\n    .playerRealName {\n      font-size: large;\n      font-weight: 700;\n      width: 100%;\n      word-break: break-all;\n      border: none;\n      padding: 5px;\n\n      .vip {\n        margin-left: 6px;\n        height: 24px;\n        width: 24px;\n      }\n    }\n  }\n\n  .playerInfoTabs {\n    width: 100%;\n    display: inline-flex;\n    flex-direction: row;\n\n    .piTab {\n      font-size: medium;\n      font-weight: 500;\n      width: 50%;\n      display: inline-flex;\n      justify-content: center;\n      cursor: pointer;\n      padding-bottom: 4px;\n      border-bottom: 2px solid $gray-box-border;\n      margin-top: 25px;\n\n      &.active {\n        font-size: medium;\n        font-weight: 500;\n        color: $active-color;\n        width: 50%;\n        display: inline-flex;\n        justify-content: center;\n        cursor: pointer;\n        padding-bottom: 4px;\n        border-bottom: 2px solid $active-color;\n      }\n    }\n  }\n\n  .stretchInfo {\n    display: flex;\n    flex-direction: column;\n    caret-color: transparent;\n    scrollbar-width: 10px;\n    overflow-y: auto;\n    padding: 0 16px;\n\n    &::-webkit-scrollbar {\n      width: 7px;\n      background-color: transparent;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: #c4c8d4cb;\n      border-radius: 7px;\n      transition: all 0.2s;\n    }\n\n    .playerInfoLine {\n      width: 100%;\n      display: inline-flex;\n      flex-direction: row;\n      gap: 16px;\n    }\n\n    .detailsLineDescr {\n      display: inline-flex;\n      justify-content: left;\n      flex-direction: column;\n      padding: 12px 0;\n      width: 100%;\n\n      .editNotes {\n        display: inline-flex;\n        flex-direction: row;\n\n        .detailsLineLabel {\n          text-align: left;\n          font-size: smaller;\n          font-weight: 200;\n          color: $text-color-600;\n          justify-content: left;\n          width: 90%;\n        }\n      }\n      .detailsLineValue {\n        text-align: left;\n      }\n    }\n\n    .detailsLine {\n      display: inline-flex;\n      justify-content: left;\n      flex-direction: column;\n      padding: 12px 0;\n      width: 100%;\n\n      .detailsLineLabel {\n        text-align: left;\n        font-size: smaller;\n        font-weight: 200;\n        color: $text-color-600;\n      }\n\n      .detailsLineValue {\n        text-align: left;\n      }\n\n      .detailsLineValueChk {\n        text-align: left;\n        display: inline-flex;\n        flex-direction: row;\n\n        .msgSwitch {\n          margin-left: 5px;\n        }\n\n        .yesNoWrap {\n          padding-left: 15px;\n          font-size: small;\n          font-weight: 400;\n        }\n      }\n\n      .playerIdLine {\n        display: inline-flex;\n        flex-direction: row;\n\n        .editorPlayerId {\n          justify-content: left;\n          width: 90%;\n          display: inline-flex;\n          flex-direction: column;\n        }\n      }\n    }\n\n    .cb {\n      border-bottom: 1px solid $gray-box-border;\n    }\n\n    // DEL CLASS\n    .dlEdit {\n      // height: 75px;\n    }\n\n    .neHi {\n      // height: 135px;\n    }\n  }\n}\n\n.infoUserWrapper {\n  margin-top: 20px;\n  display: flex;\n  flex-direction: column;\n  padding: 0 16px;\n\n  .playerInfoLine {\n    width: 100%;\n    display: inline-flex;\n    flex-direction: row;\n    gap: 16px;\n    border-bottom: 1px solid #e9e9eb;\n\n    &:last-of-type {\n      border-bottom: none;\n    }\n\n    .detailsLine {\n      display: inline-flex;\n      justify-content: left;\n      flex-direction: column;\n      padding: 12px 0;\n      width: 100%;\n\n      .detailsLineLabel {\n        text-align: left;\n        font-size: smaller;\n        font-weight: 200;\n        color: $text-color-600;\n      }\n\n      .detailsLineValue {\n        text-align: left;\n      }\n    }\n  }\n}\n\n// OLD STYLES\n\n.player-real-name {\n  font-size: large;\n  font-weight: 700;\n  display: inline-flex;\n  width: 100%;\n  justify-content: center;\n  border: none;\n  height: 35px;\n  padding: 5px;\n}\n\n.player-payid {\n  display: inline-flex;\n  width: 100%;\n  justify-content: center;\n  border: none;\n  height: 35px;\n  padding: 5px;\n}\n\n// .pi-info-tab {\n//   font-size: medium;\n//   font-weight: 500;\n//   width: 50%;\n//   display: inline-flex;\n//   justify-content: center;\n//   cursor: pointer;\n//   padding-bottom: 4px;\n//   border-bottom: 2px solid #e9e9eb;\n//   margin-top: 25px;\n// }\n\n// .pi-detail-tab {\n//   font-size: medium;\n//   font-weight: 500;\n//   width: 50%;\n//   display: inline-flex;\n//   justify-content: center;\n//   cursor: pointer;\n//   padding-bottom: 4px;\n//   border-bottom: 2px solid #e9e9eb;\n//   margin-top: 25px;\n// }\n\n// .pi-active {\n//   font-size: medium;\n//   font-weight: 500;\n//   color: rgb(95, 143, 223);\n//   width: 50%;\n//   display: inline-flex;\n//   justify-content: center;\n//   cursor: pointer;\n//   padding-bottom: 4px;\n//   border-bottom: 2px solid rgb(95, 143, 223);\n// }\n\n.details-line-rec {\n  width: 100%;\n  flex-direction: row;\n  display: inline-flex;\n  border-bottom: 1px solid #e9e9eb;\n}\n\n.cb {\n  border-bottom: 1px solid #e9e9eb;\n}\n\n.edit-btn {\n  background-color: white;\n  margin-bottom: 1px;\n  padding-top: 5px;\n  color: black;\n  border: 1px solid rgb(210, 216, 223);\n  border-radius: 7px;\n}\n\n.edit-span {\n  font-size: medium;\n  font-weight: 500;\n  vertical-align: middle;\n  padding-top: 5px;\n  padding-left: 5px;\n  color: black;\n}\n\n.edit-pen {\n  color: rgb(95, 143, 223);\n}\n\n.change-dollar {\n  color: rgb(95, 143, 223);\n  padding-top: 5px;\n}\n\n.edit-edit {\n  width: 100%;\n  flex-direction: row;\n  display: inline-flex;\n  align-content: center;\n  justify-content: center;\n}\n\n.details-line-edit {\n  width: 35px;\n  margin: 12px 0;\n}\n\n.img-space {\n  margin-left: 5px;\n}\n\n.details-line {\n  display: inline-flex;\n  justify-content: left;\n  flex-direction: column;\n  padding: 12px 0;\n  width: 100%;\n  // height: 55px;\n}\n\n.mel {\n  height: 75px;\n}\n\n.money-edit {\n  padding-left: 15px;\n  display: inline-block;\n  caret-color: black;\n}\n\n.currency-sign {\n  position: relative;\n  left: 1px;\n  top: 0;\n  width: 18px;\n  height: 20px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.notes-edit {\n  height: 100px;\n  padding-left: 5px;\n  padding-top: 5px;\n  vertical-align: top;\n  text-align: left;\n  caret-color: black;\n}\n\n.msg-switch {\n  margin-left: 5px;\n}\n\n.notes-edit-save {\n  font-size: medium;\n  font-weight: 500;\n  width: 140px;\n  color: white;\n  background-color: rgb(95, 143, 223);\n}\n\n.notes-edit-cancel {\n  font-size: medium;\n  font-weight: 500;\n  width: 140px;\n  color: black;\n  background-color: white;\n  border: 1px solid rgb(210, 216, 223);\n}\n\n.dle {\n  margin-top: 50px;\n  margin-bottom: 12px 0;\n}\n\n.dle-cancel {\n  margin-top: 50px;\n  margin-bottom: 12px 0;\n}\n\n.dle-notes-cancel {\n  margin-bottom: 35px;\n}\n\n.edit-notes {\n  display: inline-flex;\n  flex-direction: row;\n}\n\n.edit-player-id {\n  display: inline-flex;\n  flex-direction: row;\n}\n\n.player-id-line {\n  display: inline-flex;\n  flex-direction: row;\n}\n\n.edit-pen-notes {\n  justify-content: right;\n  width: 10%;\n}\n\n.edit-player-id {\n  justify-content: right;\n  width: 10%;\n}\n\n.editor-player-id {\n  justify-content: left;\n  width: 90%;\n  display: inline-flex;\n  flex-direction: column;\n}\n\n.details-line-descr {\n  display: inline-flex;\n  justify-content: left;\n  flex-direction: column;\n  padding: 12px 0;\n  width: 100%;\n}\n\n.end-line {\n  border-bottom: none;\n}\n\n.last {\n  // padding-bottom: 105px;\n}\n\n.details-line-label {\n  text-align: left;\n  font-size: smaller;\n  font-weight: 200;\n  color: #909399;\n}\n\n.details-line-value {\n  text-align: left;\n}\n\n.details-line-value-chk {\n  text-align: left;\n  display: inline-flex;\n  flex-direction: row;\n}\n\n.yesNoWrap {\n  padding-left: 15px;\n  font-size: small;\n  font-weight: 400;\n}\n\n.edit-pen {\n  color: rgb(95, 143, 223);\n  margin-top: 5px;\n  cursor: pointer;\n}\n\n.dlg-btns {\n  width: 100%;\n  display: flex;\n  gap: 16px;\n\n  button {\n    width: 100%;\n  }\n}\n\n.dlg-btn-ok {\n  align-self: center;\n  display: inline-flex;\n  padding-left: 10px;\n}\n\n.dlg-btn-cancel {\n  display: inline-flex;\n  align-self: center;\n  padding-right: 10px;\n}\n\n.dlg-btn-ok-ctrl {\n  margin-right: 10px;\n  width: 140px;\n  font-size: medium;\n  font-weight: 500;\n  color: white;\n  background-color: rgb(95, 143, 223);\n}\n\n.dlg-btn-cancel-ctrl {\n  margin-left: 10px;\n  width: 140px;\n  font-size: medium;\n  font-weight: 500;\n  color: black;\n  background-color: white;\n  border: 1px solid rgb(210, 216, 223);\n}\n\n.dlg-header {\n  caret-color: transparent;\n  width: 100%;\n  display: inline-flex;\n  flex-direction: row;\n}\n\n.dlg-header-ico {\n  position: relative;\n  left: 10px;\n  top: 5px;\n  width: 25px;\n  height: 25px;\n  display: inline-flex;\n}\n\n.dlg-header-msg {\n  // position: relative;\n  // left: 25px;\n  // top: 5px;\n  // display: inline-flex;\n}\n\n.dlg-body-msg {\n  caret-color: transparent;\n  padding-bottom: 5px;\n  display: inline-flex;\n}\n","$white: #ffffff;\n$black: #000000;\n\n$gray-background: #f5f5f7;\n$gray-border: #dce1e6;\n$gray-box-border: #e9e9eb;\n$gray-active: #eaedef;\n$active-color: #5f8fdf;\n$active-color-op: rgba(95, 143, 223, 0.4);\n// $active-color: #00ff95;\n$sender-message-color: #cce4ff;\n\n$text-color-800: #4a596a;\n$text-color-700: #626d7a;\n$text-color-600: #909399;\n\n$active-color-2: #ec205f;\n\n// $header-color: #add8e6;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"playerInfo": `style_playerInfo__FJg5D`,
	"playerInfoOpen": `style_playerInfoOpen__8ZHju`,
	"fixedInfo": `style_fixedInfo__8gdT2`,
	"playerAvatarCell": `style_playerAvatarCell__76oww`,
	"playerAvatar": `style_playerAvatar__Y0zSy`,
	"playerAvatarOk": `style_playerAvatarOk__oKrir`,
	"playerInfoCancel": `style_playerInfoCancel__umZ1H`,
	"playerRealName": `style_playerRealName__5gS+R`,
	"vip": `style_vip__B1P9z`,
	"playerInfoTabs": `style_playerInfoTabs__xIQC2`,
	"piTab": `style_piTab__h9vpk`,
	"active": `style_active__-ytvV`,
	"stretchInfo": `style_stretchInfo__-J9yP`,
	"playerInfoLine": `style_playerInfoLine__SmuMu`,
	"detailsLineDescr": `style_detailsLineDescr__HMy6e`,
	"editNotes": `style_editNotes__7rzi4`,
	"detailsLineLabel": `style_detailsLineLabel__IZql7`,
	"detailsLineValue": `style_detailsLineValue__+tUyB`,
	"detailsLine": `style_detailsLine__rB-ms`,
	"detailsLineValueChk": `style_detailsLineValueChk__FuQEA`,
	"msgSwitch": `style_msgSwitch__6Vefs`,
	"yesNoWrap": `style_yesNoWrap__vZEwz`,
	"playerIdLine": `style_playerIdLine__e1Re5`,
	"editorPlayerId": `style_editorPlayerId__jDwnu`,
	"cb": `style_cb__fxkUA`,
	"infoUserWrapper": `style_infoUserWrapper__XDwjT`,
	"player-real-name": `style_player-real-name__AG86n`,
	"player-payid": `style_player-payid__p8Fn8`,
	"details-line-rec": `style_details-line-rec__p5GwT`,
	"edit-btn": `style_edit-btn__0WxUC`,
	"edit-span": `style_edit-span__8ealJ`,
	"edit-pen": `style_edit-pen__vBLe3`,
	"change-dollar": `style_change-dollar__wv7-6`,
	"edit-edit": `style_edit-edit__9FeFJ`,
	"details-line-edit": `style_details-line-edit__ndMtk`,
	"img-space": `style_img-space__Qe4Ze`,
	"details-line": `style_details-line__1d77P`,
	"mel": `style_mel__u5-Kn`,
	"money-edit": `style_money-edit__5Bhse`,
	"currency-sign": `style_currency-sign__tA8Mv`,
	"notes-edit": `style_notes-edit__3GBPW`,
	"msg-switch": `style_msg-switch__Kyu+J`,
	"notes-edit-save": `style_notes-edit-save__EJnw5`,
	"notes-edit-cancel": `style_notes-edit-cancel__a6FHe`,
	"dle": `style_dle__K72up`,
	"dle-cancel": `style_dle-cancel__LkJN9`,
	"dle-notes-cancel": `style_dle-notes-cancel__deUl6`,
	"edit-notes": `style_edit-notes__QMH19`,
	"edit-player-id": `style_edit-player-id__HedEz`,
	"player-id-line": `style_player-id-line__QMPHx`,
	"edit-pen-notes": `style_edit-pen-notes__InLY1`,
	"editor-player-id": `style_editor-player-id__p6X2C`,
	"details-line-descr": `style_details-line-descr__W0H9J`,
	"end-line": `style_end-line__hpIaS`,
	"details-line-label": `style_details-line-label__pDqvv`,
	"details-line-value": `style_details-line-value__i0nD8`,
	"details-line-value-chk": `style_details-line-value-chk__1jxmJ`,
	"dlg-btns": `style_dlg-btns__LEuER`,
	"dlg-btn-ok": `style_dlg-btn-ok__FaOXf`,
	"dlg-btn-cancel": `style_dlg-btn-cancel__H2jTt`,
	"dlg-btn-ok-ctrl": `style_dlg-btn-ok-ctrl__YUWXS`,
	"dlg-btn-cancel-ctrl": `style_dlg-btn-cancel-ctrl__w1tEH`,
	"dlg-header": `style_dlg-header__xFOe5`,
	"dlg-header-ico": `style_dlg-header-ico__Asaui`,
	"dlg-body-msg": `style_dlg-body-msg__8ka4U`
};
export default ___CSS_LOADER_EXPORT___;
